import { IOptions } from "store/sidebar/types"

export const PORTAL_ROOT_ID = 'portal-root'

export const USER_ROLES = {
    admin: 'Global Admin',
    client: 'Client Admin',
    user: 'User'
}

export const datasetOptions: IOptions[] = [
  { name: "Location", id: "239", type: "" },
  { name: "Subsurface Assets", id: "1", type: "" },
  { name: "Infrastructure Assets", id: "2", type: "" },
  { name: "CO2 Emitters", id: "4", type: "" },
  { name: "CCS Projects", id: "8", type: "" },
  { name: "Blocks", id: "32", type: "" },
  { name: "Licences", id: "64", type: "" },
  { name: "Windfarms", id: "128", type: "" },
]

export const datasetOptionsMapping = {
  1: "Subsurface Assets",
  2: "Infrastructure Assets",
  4: "CO2 Emitters",
  5: "Common Data",
  8: "CCS Projects",
  32: "Blocks",
  64: "Licences",
  128: "Windfarms",
  239: "Location",
}

export const datasetOptionsMappingEmissions = {
    1: 'Subsurface Assets',
    2: 'Infrastructure Assets',
    4: 'Emissions',
    5: 'Common Data',
    8: 'CCS Projects',
    32: 'Blocks',
    64: 'Licences',
    128: 'Windfarms',
}

export const datasetsIds = datasetOptions.map(item=>+item.id)

export const unitOptions = [{ name: 'Field', id: '1' }, { name: 'Metric', id: '2' }]


export const MappingOptionType = {
    title: 8,
    x: 5,
    y: 6,
    y2: 7
}


export const MappingOptionTypeReverse = {
    8: 'title',
    5: 'x',
    6: 'y',
    7: 'y2',
}

// WorkspaceOptionType.Imputed. One row per workspace, addressed by no identifier field, because the
// same colour marks imputed data on every plot type - stars, striped bars and shaded grid cells.
export const IMPUTED_OPTION_TYPE = 11

// WorkspaceOptionType.HistogramUser. Also addressed by no identifier field: the histogram's user
// bars aggregate every user field, so there is no one field to hang the colour on.
export const USER_DATA_OPTION_TYPE = 12

// Map asset type name to type number for API filtering
export const mapAssetTypeToTypeNumber = (assetType: string): number => {
    const assetTypeMapping: Record<string, number> = {
        'Subsurface Assets': 1,
        'Infrastructure Assets': 2,
        'Infrastructure': 2,
        'CO2 Emitters': 4,
        'Emissions': 4,
        'CCS Projects': 8,
        'Blocks': 32,
        'Licences': 64,
        'Windfarms': 128,
    };
    
    return assetTypeMapping[assetType] || 1; // Default to Subsurface Assets
};